const TailArrow = (props) => {
  const rotationDeg = props?.rotate || 0;
  return (
    <svg
      width={props?.width || 24}
      height={props?.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotationDeg}deg)`,
        transition: "transform 0.3s ease",
      }}
      className={props?.className||""}
    >
      <path
        d="M12 6V18M12 18L7 13M12 18L17 13"
        stroke={props?.color || "#1a325d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
 
export default TailArrow;